import { ContractDetailsGlobal } from "api/contract";
import { EntityDetailsStat, EntityDetailsStatConfig } from "components/display/EntityDetailsStat";
import moment from "moment";
import React, { useMemo } from "react";

interface ContractDetailsStatProps {
  contractDetails: ContractDetailsGlobal;
  className?: string;
}

const ContractDetailStat: React.FC<ContractDetailsStatProps> = ({
  contractDetails,
  className = ""
}) => {
  // Construire la configuration
  const config: EntityDetailsStatConfig = useMemo(() => {
    return {
      stats: [
        {
          label: 'Type',
          value: contractDetails.branchCode
        },
        {
          label: 'Assureur',
          value: contractDetails.productOwner
        },
        {
          label: "Date d'effet",
          value: moment(contractDetails.startDate).format("DD MMM YYYY")
        },
        {
          label: 'Échéance principale',
          value: contractDetails.mainDueDate
        },
        {
          label: 'Périodicité de paiement',
          value: contractDetails.paymentFrequency
        },
        // Libellé fourni tel quel par le back (souscripteur, courtier encaisseur,
        // souscripteur du contrat collectif).
        {
          label: 'Quittancé par',
          value: contractDetails.billedBy || '—'
        },
        {
          label: 'Prime annuelle',
          value: `${contractDetails.clientPrice.toFixed(2)} €`
        }
      ],
      emptyStateConfig: {
        message: "Aucune information disponible pour ce contrat"
      },
      // Configuration optionnelle de la grille (utilise les valeurs par défaut si non spécifié)
      gridConfig: {
        mobile: "flex gap-3 settings_contractProperties_container",
        desktop: "grid grid-cols-1 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-7 gap-4"
      }
    };
  }, [contractDetails]);

  return <EntityDetailsStat config={config} className={className} />;
};

export default ContractDetailStat;
